// 后端 API 基础 URL
const API_BASE_URL =
  import.meta.env.VITE_API_URL || 'http://localhost:3001/api';

// 存储 admin token 的键名
const ADMIN_TOKEN_KEY = 'metalbox_admin_token';
const ADMIN_USER_KEY = 'metalbox_admin_user';
const ADMIN_LOGIN_TIME_KEY = 'metalbox_admin_login_time';
// 登录有效时间（分钟）
const LOGIN_EXPIRY_MINUTES = 30;

// 获取 admin token
export const getAdminToken = () => {
  const token = localStorage.getItem(ADMIN_TOKEN_KEY);
  console.log(
    '🔍 获取 token:',
    token ? `${token.substring(0, 20)}...` : 'null'
  );
  return token;
};

// 设置 admin token
export const setAdminToken = (token) => {
  console.log('💾 保存 token 到 localStorage...');
  console.log('   Key:', ADMIN_TOKEN_KEY);
  console.log('   Token 长度:', token.length);
  localStorage.setItem(ADMIN_TOKEN_KEY, token);
  // 存储登录时间
  localStorage.setItem(ADMIN_LOGIN_TIME_KEY, Date.now().toString());
  console.log(
    '✅ Token 保存完成，验证:',
    localStorage.getItem(ADMIN_TOKEN_KEY) ? '成功' : '失败'
  );
};

// 移除 admin token
export const removeAdminToken = () => {
  console.log('🗑️  调用 removeAdminToken，堆栈跟踪：');
  console.trace();
  localStorage.removeItem(ADMIN_TOKEN_KEY);
  localStorage.removeItem(ADMIN_LOGIN_TIME_KEY);
};

// 移除管理员用户信息
export const removeAdminUser = () => {
  localStorage.removeItem(ADMIN_USER_KEY);
};

// 获取管理员用户信息
export const getAdminUser = () => {
  const user = localStorage.getItem(ADMIN_USER_KEY);
  return user ? JSON.parse(user) : null;
};

// 设置管理员用户信息
export const setAdminUser = (user) => {
  localStorage.setItem(ADMIN_USER_KEY, JSON.stringify(user));
};

// 检查登录是否已过期
export const isLoginExpired = () => {
  const token = localStorage.getItem(ADMIN_TOKEN_KEY);
  if (!token) {
    console.log('没有token，登录是无效的');
    return true;
  }

  // 检查登录时间是否超过30分钟
  const loginTime = localStorage.getItem(ADMIN_LOGIN_TIME_KEY);
  if (!loginTime) {
    console.log('没有登录时间记录，登录无效');
    return true;
  }

  const elapsedMinutes = (Date.now() - parseInt(loginTime)) / (1000 * 60);
  console.log(`已登录 ${Math.floor(elapsedMinutes)} 分钟`);

  if (elapsedMinutes > LOGIN_EXPIRY_MINUTES) {
    console.log(`登录已过期（超过 ${LOGIN_EXPIRY_MINUTES} 分钟）`);
    return true;
  }

  console.log('登录有效，未超过30分钟');
  return false;
};

// 获取带 token 的请求头
const getAuthHeaders = () => {
  const token = getAdminToken();
  return {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
  };
};

// 管理员登录
export const adminLogin = async (email, password) => {
  console.log('🔐 开始登录流程...');
  try {
    const response = await fetch(`${API_BASE_URL}/auth/admin-login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email, password }),
    });

    console.log('📡 后端响应状态:', response.status);
    const data = await response.json();
    console.log('📦 后端返回数据:', data);

    if (data.success) {
      console.log('✅ 登录成功，保存 token...');
      setAdminToken(data.token);
      setAdminUser(data.user);
      console.log(
        '💾 Token 已保存:',
        localStorage.getItem(ADMIN_TOKEN_KEY) ? '是' : '否'
      );
      console.log(
        '💾 登录时间已保存:',
        localStorage.getItem(ADMIN_LOGIN_TIME_KEY)
      );
      return { success: true, user: data.user };
    } else {
      console.log('❌ 登录失败:', data.message);
      return { success: false, message: data.message };
    }
  } catch (error) {
    console.error('❌ 登录异常:', error);
    return { success: false, message: '网络错误：' + error.message };
  }
};

// 管理员登出
export const adminLogout = () => {
  removeAdminToken();
  removeAdminUser();
};

// 检查管理员认证状态
export const checkAdminAuth = async () => {
  // 先检查本地 token
  const token = getAdminToken();
  if (!token) {
    console.log('❌ No token found');
    return { isAuthenticated: false };
  }

  // 检查登录时间是否超过30分钟
  const loginTime = localStorage.getItem(ADMIN_LOGIN_TIME_KEY);
  if (!loginTime) {
    console.log('❌ No login time found');
    return { isAuthenticated: false };
  }

  const elapsedMinutes = (Date.now() - parseInt(loginTime)) / (1000 * 60);
  console.log(`⏱️  已登录 ${Math.floor(elapsedMinutes)} 分钟`);

  if (elapsedMinutes > LOGIN_EXPIRY_MINUTES) {
    console.log(`❌ 登录已过期（超过 ${LOGIN_EXPIRY_MINUTES} 分钟）`);
    removeAdminToken();
    removeAdminUser();
    return { isAuthenticated: false };
  }

  try {
    // 验证 token 的有效性
    const response = await fetch(`${API_BASE_URL}/auth/me`, {
      method: 'GET',
      headers: getAuthHeaders(),
    });

    if (!response.ok) {
      console.log('❌ API response not OK:', response.status);
      removeAdminToken();
      removeAdminUser();
      return { isAuthenticated: false };
    }

    const data = await response.json();

    // 检查响应状态和用户角色
    console.log('🔍 检查用户数据:', {
      success: data.success,
      hasUser: !!data.user,
      userRole: data.user?.role,
      fullData: data,
    });

    if (data.success && data.user && data.user.role === 'admin') {
      setAdminUser(data.user);
      console.log('✅ Auth check passed');
      return { isAuthenticated: true, user: data.user };
    } else {
      console.log('❌ Invalid auth response:', data);
      removeAdminToken();
      removeAdminUser();
      return { isAuthenticated: false };
    }
  } catch (error) {
    console.error('❌ Auth check error:', error.message);
    // 网络错误但时间未过期，暂时保持登录状态
    console.log('⚠️  Network error, keeping login state temporarily');
    return { isAuthenticated: true };
  }
};

// 通用 fetch 方法（带认证）
export const apiCall = async (endpoint, options = {}) => {
  const url = `${API_BASE_URL}${endpoint}`;
  const token = getAdminToken();

  // 如果是 FormData，不设置 Content-Type
  const headers = options.isFormData
    ? {
      ...(token && { Authorization: `Bearer ${token}` }),
      ...options.headers,
    }
    : {
      ...getAuthHeaders(),
      ...options.headers,
    };

  try {
    const response = await fetch(url, {
      ...options,
      headers,
    });

    const data = await response.json();

    if (response.status === 401) {
      // Token 过期或无效
      removeAdminToken();
      removeAdminUser();
      window.location.href = '/login';
    }

    return data;
  } catch (error) {
    return { success: false, message: error.message };
  }
};

// 获取联系消息列表
export const getContactMessages = async (page = 1, limit = 20, status) => {
  const statusParam = status ? `&status=${status}` : '';
  return apiCall(
    `/admin/contact-messages?page=${page}&limit=${limit}${statusParam}`
  );
};

// 获取联系消息详情
export const getContactMessage = async (id) => {
  return apiCall(`/admin/contact-messages/${id}`);
};

// 更新联系消息状态
export const updateContactMessageStatus = async (id, status, notes = '') => {
  return apiCall(`/admin/contact-messages/${id}`, {
    method: 'PUT',
    body: JSON.stringify({ status, admin_notes: notes }),
  });
};

// 删除联系消息
export const deleteContactMessage = async (id) => {
  return apiCall(`/admin/contact-messages/${id}`, {
    method: 'DELETE',
  });
};

// 发送回复邮件
export const sendReplyToContact = async (
  id,
  replyContent,
  attachments = []
) => {
  const formData = new FormData();
  formData.append('replyContent', replyContent);

  // 添加附件
  if (attachments && attachments.length > 0) {
    for (const file of attachments) {
      formData.append('attachments', file);
    }
  }

  return apiCall(`/admin/contact-messages/${id}/reply`, {
    method: 'POST',
    body: formData,
    // 不设置 Content-Type，让浏览器自动设置
    headers: {
      // 不包含 'Content-Type': 'application/json'
    },
    isFormData: true, // 标记为 FormData
  });
};

// 获取用户列表
export const getUsers = async (page = 1, limit = 20) => {
  return apiCall(`/admin/users?page=${page}&limit=${limit}`);
};

// 获取用户详情
export const getUser = async (id) => {
  return apiCall(`/admin/users/${id}`);
};

// 获取已删除用户列表
export const getDeletedUsers = async (page = 1, limit = 20) => {
  return apiCall(`/admin/deleted-users?page=${page}&limit=${limit}`);
};

// 删除用户
export const deleteUser = async (id, reason = '') => {
  return apiCall(`/admin/users/${id}`, {
    method: 'DELETE',
    body: JSON.stringify({ reason }),
  });
};

// 恢复已删除用户
export const restoreUser = async (id) => {
  return apiCall(`/admin/users/${id}/restore`, {
    method: 'POST',
  });
};

// 彻底删除用户(从数据库永久删除)
export const permanentlyDeleteUser = async (id) => {
  return apiCall(`/admin/users/${id}/permanent`, {
    method: 'DELETE',
  });
};

// 获取系统统计数据
export const getStats = async () => {
  return apiCall('/admin/stats');
};

// 导出 API_BASE_URL 供其他组件使用
export { API_BASE_URL };
